import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import LabelValue from '../../LabelValue';
import { Tier3Provider } from '../../../data/models/provider.model';
import { PhoneNumber } from '../../../data/models/phone-number.model';
import phoneUtils from '../../../services/phoneUtils';
import { useBooleanStatus } from '../../../hooks/useBooleanStatus';
import { FULLSTORY_MASK_CLASSNAME } from '../../../services/analyticsUtils';
import { usePhone } from '../../../hooks/usePhone';

interface Tier3ContactInfoProps {
  provider: Tier3Provider | null;
  titleStyle: string;
  isInternalUser: boolean;
}

export default function Tier3ContactInfo(props: Tier3ContactInfoProps) {
  const { t } = useTranslation('common');

  const { provider, titleStyle, isInternalUser } = props;

  const getContactPhoneNumber = (
    provider: Tier3Provider | null,
  ): PhoneNumber | null => {
    let phoneNumber = null;
    if (provider?.phoneNumbers?.length) {
      phoneNumber = provider.phoneNumbers[0];
    }

    return phoneNumber;
  };

  const getContactName = (provider: Tier3Provider | null) => {
    const num = getContactPhoneNumber(provider);
    return num ? `${num.contactFirstName} ${num.contactLastName}` : '';
  };

  const getEmail = (provider: Tier3Provider | null) => {
    let email = '';
    if (provider?.emailAddresses?.length) {
      const e = provider.emailAddresses[0];
      email = `${e.emailAddress}`;
    }
    return email;
  };

  const getContactPhone = (provider: Tier3Provider | null) => {
    const num = getContactPhoneNumber(provider);
    return phoneUtils.formatPhone(num || undefined);
  };

  const getCoverageAreas = (provider: Tier3Provider | null) => {
    let coverageAreas = '';
    if (provider?.coverageAreas) {
      coverageAreas = provider.coverageAreas
        .map((ca) => ca.coverageAreaName)
        .join(', ');
    }
    return coverageAreas;
  };

  return (
    <>
      <Typography className={titleStyle}>{t('provider.contact')}</Typography>
      <Grid container spacing={2}>
        <Grid item sm={12} md={6}>
          <LabelValue
            label={t('provider.name')}
            value={provider?.transportationProviderName}
          />
        </Grid>
        <Grid item sm={12} md={6}>
          <LabelValue
            label={t('common.city')}
            value={provider?.legalEntityCity || ''}
            className={FULLSTORY_MASK_CLASSNAME}
          />
        </Grid>
        <Grid item sm={12} md={6}>
          <LabelValue
            label={t('common.state')}
            value={provider?.legalEntityStateCode || ''}
            className={FULLSTORY_MASK_CLASSNAME}
          />
        </Grid>
        <Grid item sm={12} md={12}>
          <LabelValue
            label={t('provider.contactName')}
            value={getContactName(provider)}
            className={FULLSTORY_MASK_CLASSNAME}
          />
        </Grid>
        <Grid item sm={12} md={6}>
          <LabelValue
            label={t('provider.contactEmail')}
            value={getEmail(provider)}
            className={FULLSTORY_MASK_CLASSNAME}
          />
        </Grid>
        <Grid item sm={12} md={6}>
          <LabelValue
            label={t('provider.contactPhone')}
            value={(() => {
              const phone = getContactPhoneNumber(provider) || undefined;
              return phone
                ? `${phone.phoneNumber} ${
                    phone.phoneExtension
                      ? `${t('common.extension')}. ${phone.phoneExtension}`
                      : ''
                  }`
                : '';
            })()}
            className={FULLSTORY_MASK_CLASSNAME}
          />
        </Grid>
        {/* <Grid item sm={12}>
          <LabelValue
            label={t('provider.coverageAreas')}
            value={getCoverageAreas(provider)}
            className={FULLSTORY_MASK_CLASSNAME}
          />
        </Grid>
        {isInternalUser && (
          <Grid item sm={12}>
            <LabelValue
              label={t('provider.isInternal')}
              value={useBooleanStatus(provider?.isInternal)}
            />
          </Grid>
        )} */}
        {/* <Grid item sm={12} md={6}>
          <LabelValue
            label={t('provider.contactLast')}
            value={mainPhone?.ContactLastName}
            className={FULLSTORY_MASK_CLASSNAME}
          />
        </Grid>
        <AddressDisplay address={address?.Address} showCounty={true} />
        <Grid item sm={12} md={6}>
          <LabelValue
            className={FULLSTORY_MASK_CLASSNAME}
            label={t('provider.mainPhone')}
            value={usePhone(
              phoneUtils.getProviderPhone(
                provider?.PhoneNumbers,
                ProviderPhoneUse.Main,
              ),
            )}
          />
        </Grid> */}
      </Grid>
    </>
  );
}
